import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Stack, Typography } from "@mui/material";

const NO_SPEC_LABEL = "Required dimension without tolerances";

const Dot = () => (
	<Box
		component="span"
		sx={{
			backgroundColor: "warning.main",
			borderRadius: "50%",
			display: "inline-block",
			flexShrink: 0,
			height: 6,
			width: 6,
		}}
	/>
);

/** Marks a column without tolerances in a Section-Rev that has some. */
export const TestShackReportNoSpecDot = () => (
	<Box
		component="span"
		role="img"
		aria-label={NO_SPEC_LABEL}
		sx={{ display: "inline-flex", ml: 0.5, verticalAlign: "middle" }}
	>
		<Dot />
	</Box>
);

export const TestShackReportNoSpecLegend = () => (
	<Stack
		direction="row"
		spacing={0.75}
		alignItems="center"
		data-test-id="report-no-spec-legend"
	>
		<Dot />
		<Typography component="span" color="text.secondary" fontSize="11px">
			{NO_SPEC_LABEL}
		</Typography>
	</Stack>
);

/** Shown instead of any verdict when the Section-Rev has no specification at all. */
export const TestShackReportNoSpecificationLegend = () => (
	<Stack
		direction="row"
		spacing={0.75}
		alignItems="center"
		data-test-id="report-no-specification-legend"
	>
		<InfoOutlinedIcon color="warning" sx={{ fontSize: 14 }} />
		<Typography component="span" color="text.secondary" fontSize="11px">
			No specification for this Section-Rev. Readings can't be evaluated.
		</Typography>
	</Stack>
);
